import { Component } from '@angular/core';
import { BaseDefaultListFilterComponent } from 'yt-ng-framework';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';

@Component({
    selector: 'default-filter',
    templateUrl: './default-filter.component.html'
})
export class DefaultFilter extends BaseDefaultListFilterComponent {

    constructor(protected datePipe: DatePipe
    ){
        super(datePipe);
    }

    ngOnInit(){
       this.SetInitParameters();
    }

    SetFilterDescription(){
        super.SetFilterDescription();
        this.FilterDescription = 'Od: ' + this.GetPropertyValue(this.filterFormGroup.get('DateFrom').value, 'date') + 
                                 ', Do: ' + this.GetPropertyValue(this.filterFormGroup.get('DateTo').value, 'date') 
    }

    SetInitParameters(){
        super.SetInitParameters();
        let date = new Date();
        this.filterFormGroup = new FormGroup({
            DateFrom: new FormControl(new NgbDate(date.getFullYear(), 1, 1), [Validators.required]),
            DateTo: new FormControl(new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate()), [Validators.required])        })
      }
}